module.exports = __webpack_public_path__ + "static/The Climate Service-949b12156d0aac6374fdf08d31540158.jpg";